import React from 'react';

const AdministratingVaccinesToAdults = () => {
  const styles = {
    container: {
      background: 'white',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
      maxWidth: '100%'
    },
    heading: {
      color: '#333'
    },
    ul: {
      paddingLeft: '20px'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      tableLayout: 'fixed',
      margin: 'auto'
    },
    tableCell: {
      border: '1px solid rgb(190, 184, 184)',
      padding: '5px',
      textAlign: 'left',
      fontSize: '14px',
      wordWrap: 'break-word',
      whiteSpace: 'normal'
    },
    tableHeader: {
      border: '1px solid rgb(190, 184, 184)',
      padding: '5px',
      textAlign: 'left',
      fontSize: '14px',
      wordWrap: 'break-word',
      whiteSpace: 'normal',
      backgroundColor: '#f2f2f2'
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Administering Vaccines to Adults: Dose, Route, Site, Needle Size, and Preparation</h2>
      <br />
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.tableHeader}>Vaccine</th>
            <th style={styles.tableHeader}>Dose</th>
            <th style={styles.tableHeader}>Route</th>
            <th style={styles.tableHeader}>Site</th>
            <th style={styles.tableHeader}>Needle Size</th>
            <th style={styles.tableHeader}>Vaccine Preparation</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={styles.tableCell}>Tetanus, Diphtheria (Td) with <br /> Pertussis (Tdap)</td>
            <td style={styles.tableCell}>0.5 mL</td>
            <td style={styles.tableCell}>IM</td>
            <td style={styles.tableCell}>Deltoid muscle</td>
            <td style={styles.tableCell}>22 to 25 g, 1 to 1½"* </td>
            <td style={styles.tableCell} rowSpan="8">Shake vial vigorously to obtain a uniform suspension prior to withdrawing each dose.
              Whenever
              solution and container permit, inspect vaccine visually for particulate matter and/or
              discoloration prior to administration. If problems are noted (e.g., vaccine cannot be
              resuspended), the vaccine should not be administered.</td>
          </tr>
          <tr>
            <td style={styles.tableCell}>Hepatitis A (HepA)</td>
            <td style={styles.tableCell}>18 yrs: 0.5 mL<br />≥19 yrs: 1.0 mL</td>
            <td style={styles.tableCell}>IM</td>
            <td style={styles.tableCell}>Deltoid muscle</td>
            <td style={styles.tableCell}>22 to 25 g, 1 to 1½"*</td>
          </tr>
          <tr>
            <td style={styles.tableCell}>Hepatitis B (HepB)</td>
            <td style={styles.tableCell}>≤19 yrs: 0.5 mL<br />≥20 yrs: 1.0 mL</td>
            <td style={styles.tableCell}>IM</td>
            <td style={styles.tableCell}>Deltoid muscle</td>
            <td style={styles.tableCell}>22 to 25 g, 1 to 1½"*</td>
          </tr>
          <tr>
            <td style={styles.tableCell}>HepA+HepB (Twinrix)</td>
            <td style={styles.tableCell}>≥18 yrs: 1.0 mL</td>
            <td style={styles.tableCell}>IM</td>
            <td style={styles.tableCell}>Deltoid muscle</td>
            <td style={styles.tableCell}>22 to 25 g, 1 to 1½"*</td>
          </tr>
          <tr>
            <td style={styles.tableCell}>Human papillomavirus (HPV)</td>
            <td style={styles.tableCell}>0.5 mL</td>
            <td style={styles.tableCell}>IM</td>
            <td style={styles.tableCell}>Deltoid muscle</td>
            <td style={styles.tableCell}>22 to 25 g, 1 to 1½"*</td>
          </tr>
          <tr>
            <td style={styles.tableCell}>Influenza, trivalent inactivated (TIV)</td>
            <td style={styles.tableCell}>0.5 mL</td>
            <td style={styles.tableCell}>IM</td>
            <td style={styles.tableCell}>Deltoid muscle</td>
            <td style={styles.tableCell}>22 to 25 g, 1 to 1½"*</td>
          </tr>
          {/* <tr>
            <td>Pneumococcal polysaccharide (PPSV)</td>
            <td>0.5 mL</td>
            <td>IM<br />SC</td>
            <td>Deltoid muscle<br />Fatty tissue over triceps</td>
            <td>22 to 25 g, 1 to 1½"<br />23 to 25 g, ⅝"</td>
          </tr> */}
          <tr>
            <td style={styles.tableCell} rowSpan="2">Pneumococcal polysaccharide (PPSV)</td>
            <td style={styles.tableCell} rowSpan="2">0.5 mL</td>
            <td style={styles.tableCell}>IM</td>
            <td style={styles.tableCell}>Deltoid muscle</td>
            <td style={styles.tableCell}>22 to 25 g, 1 to 1½"*</td>
          </tr>
          <tr>
            <td style={styles.tableCell}>SC</td>
            <td style={styles.tableCell}>Fatty tissue over triceps</td>
            <td style={styles.tableCell}>23 to 25 g, ⅝"</td>
          </tr>
          <tr>
            <td style={styles.tableCell}>Meningococcal, conjugated (MCV)</td>
            <td style={styles.tableCell}>0.5 mL</td>
            <td style={styles.tableCell}>IM</td>
            <td style={styles.tableCell}>Deltoid muscle</td>
            <td style={styles.tableCell}>22 to 25 g, 1 to 1½"*</td>
            <td style={styles.tableCell}></td>
          </tr>
          <tr>
            <td style={styles.tableCell}>Meningococcal, polysaccharide (MPSV)</td>
            <td style={styles.tableCell}>0.5 mL</td>
            <td style={styles.tableCell}>SC</td>
            <td style={styles.tableCell}>Fatty tissue over triceps</td>
            <td style={styles.tableCell}>23 to 25 g, ⅝"</td>
            <td style={styles.tableCell} rowSpan="4">Reconstitute just before using. Use only the diluent supplied with the vaccine.
              Inject the
              volume of the diluent shown on the diluent label into the vial of lyophilized vaccine and gently
              agitate to mix thoroughly. Withdraw the entire contents and administer immediately after
              reconstitution.
              <br />
              Discard single dose MPSV, varicella, and zoster vaccines if not used within 30 minutes after
              reconstitution.
              <br />
              NOTE: Unused reconstituted MMR vaccine and multidose MPSV vaccine may be stored at 35°46°F
              (2°8°C) for a limited time. The reconstituted MPSV vaccine must be used within 35 days; the
              reconstituted MMR vaccine must be used within 8 hours. Do not freeze either reconstituted
              vaccine.
            </td>
          </tr>
          <tr>
            <td style={styles.tableCell}>Measles, mumps, rubella (MMR)</td>
            <td style={styles.tableCell}>0.5 mL</td>
            <td style={styles.tableCell}>SC</td>
            <td style={styles.tableCell}>Fatty tissue over triceps</td>
            <td style={styles.tableCell}>23 to 25 g, ⅝"</td>
          </tr>
          <tr>
            <td style={styles.tableCell}>Zoster (ZOS)</td>
            <td style={styles.tableCell}>0.65 mL</td>
            <td style={styles.tableCell}>SC</td>
            <td style={styles.tableCell}>Fatty tissue over triceps</td>
            <td style={styles.tableCell}>23 to 25 g, ⅝"</td>
          </tr>
          <tr>
            <td style={styles.tableCell}>Varicella (Var)</td>
            <td style={styles.tableCell}>0.5 mL</td>
            <td style={styles.tableCell}>SC</td>
            <td style={styles.tableCell}>Fatty tissue over triceps</td>
            <td style={styles.tableCell}>23 to 25 g, ⅝"</td>
          </tr>
          <tr>
            <td style={styles.tableCell}>Influenza, live, attenuated (LAIV)</td>
            <td style={styles.tableCell}>0.2 mL (0.1 mL into each nostril)</td>
            <td style={styles.tableCell}>Intranasal spray</td>
            <td style={styles.tableCell}>Intranasal</td>
            <td style={styles.tableCell}>NA</td>
            <td style={styles.tableCell}>Consult package insert</td>
          </tr>
        </tbody>
      </table>
      
      {/* <div style={{width: 'max', height: '1px', backgroundColor: 'rgb(190, 184, 184)'}}></div> */}
      <br />
      <footer>
        <p>Information sourced from uptodate.com</p>
      </footer>
    </div>
  );
};

export default AdministratingVaccinesToAdults; 